import React from 'react';
import {
  List,
  Datagrid,
  TextField,
  NumberField,
  DateField,
  useTranslate,
  TopToolbar,
  SelectColumnsButton,
  ExportButton,
  useRecordContext,
  Button,
} from 'react-admin';
import { FilterLiveSearch, useListContext } from 'react-admin';
import { Card, CardContent, Stack } from '@mui/material';
import { Link } from 'react-router-dom';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import AnalyticsIcon from '@mui/icons-material/Analytics';

const BuyerFilterSidebar = () => {
  const translate = useTranslate();

  return (
    <Card
      sx={{
        order: -1,
        mr: 2,
        mt: 9,
        minWidth: 250,
        maxWidth: 300,
        boxShadow: 0,
        borderRadius: 2,
      }}
    >
      <CardContent>
        <Stack spacing={1.5}>
          <FilterLiveSearch
            source="name"
            label={translate('resources.buyers.fields.name')}
          />
          <FilterLiveSearch
            source="tax_number"
            label={translate('resources.buyers.fields.tax_number')}
          />
          <FilterLiveSearch
            source="registration_number"
            label={translate('resources.buyers.fields.registration_number')}
          />
          <FilterLiveSearch
            source="city"
            label={translate('resources.buyers.fields.city')}
          />
          <FilterLiveSearch
            source="municipality"
            label={translate('resources.buyers.fields.municipality')}
          />
          <FilterLiveSearch
            source="province"
            label={translate('resources.buyers.fields.province')}
          />
          <FilterLiveSearch
            source="party_type"
            label={translate('resources.buyers.fields.party_type')}
          />
        </Stack>
      </CardContent>
    </Card>
  );
};

const PredictionsButton = () => {
  const record = useRecordContext();
  const translate = useTranslate();

  if (!record || !record.id) return null;

  const handleClick = (e) => {
    e.stopPropagation();
  };

  return (
    <Button
      component={Link}
      to={`/ordering-parties/${record.id}/show/2`}
      label={translate('resources.buyers.tabs.predictions', 'Predykcje')}
      startIcon={<AnalyticsIcon />}
      onClick={handleClick}
      sx={{
        textTransform: 'none',
      }}
    />
  );
};

const ListActions = () => {
  return (
    <TopToolbar>
      <SelectColumnsButton />
      <ExportButton
        maxResults={100000}
        icon={<FileDownloadIcon />}
        sx={{
          backgroundColor: '#E31837',
          color: '#ffffff',
          '&:hover': {
            backgroundColor: '#C0142F',
          },
          '& .MuiSvgIcon-root': {
            color: '#ffffff',
          },
        }}
      />
    </TopToolbar>
  );
};

export const OrderPredictionsList = () => {
  const translate = useTranslate();
  return (
    <List
      resource="ordering-parties"
      perPage={25}
      sort={{ field: 'created_at', order: 'DESC' }}
      actions={<ListActions />}
      aside={<BuyerFilterSidebar />}
    >
      <Datagrid rowClick={(id) => `/ordering-parties/${id}/show/2`} bulkActionButtons={false}>
        <TextField
          source="id"
          label={translate('resources.buyers.fields.id')}
        />
        <TextField
          source="name"
          label={translate('resources.buyers.fields.name')}
        />
        <TextField
          source="tax_number"
          label={translate('resources.buyers.fields.tax_number')}
        />
        <TextField
          source="registration_number"
          label={translate('resources.buyers.fields.registration_number')}
        />
        <TextField
          source="city"
          label={translate('resources.buyers.fields.city')}
        />
        <TextField
          source="municipality"
          label={translate('resources.buyers.fields.municipality')}
        />
        <TextField
          source="province"
          label={translate('resources.buyers.fields.province')}
        />
        <TextField
          source="party_type"
          label={translate('resources.buyers.fields.party_type')}
        />
        <NumberField
          source="total_tenders"
          label={translate('resources.buyers.fields.total_tenders')}
        />
        <NumberField
          source="active_tenders"
          label={translate('resources.buyers.fields.active_tenders')}
        />
        <DateField
          source="updated_at"
          label={translate('resources.buyers.fields.updated_at')}
          showTime
        />
        <PredictionsButton />
      </Datagrid>
    </List>
  );
};
